import { WithChildrenProps } from "types/generalTypes";
import * as S from "./styles";

interface MainHeaderProps extends WithChildrenProps {
  isTwoColumnsLayout: boolean;
}

export const MainHeader = ({
  isTwoColumnsLayout,
  children,
}: MainHeaderProps) => {
  return (
    <S.Header $isTwoColumnsLayoutHeader={isTwoColumnsLayout}>
      {children}
    </S.Header>
  );
};
